import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Button } from "src/app/shared/components/utils/button/button";
import { TranslocoModule } from "@jsverse/transloco";
import { Icon } from "src/app/shared/components/utils/icon/icon";
import { PianoAnalyticsService } from "src/app/core/services/piano-analytics";

@Component({
  selector: "app-journey-landing-page",
  imports: [Button, TranslocoModule, Icon],
  templateUrl: "./journey-landing-page.html",
})
export class JourneyLandingPage implements OnInit {
  readonly router = inject(Router);
  readonly piano = inject(PianoAnalyticsService);

  ngOnInit(): void {
    this.piano.trackPageDisplay("journey_landing", "/journey");
  }

  accessJourneySearchPage() {
    this.router.navigate(["/journey/search"]);
  }
}
